import "./scss/style.scss";

console.log('loaded');
